var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "min-h-screen flex"
  }, [_c('div', {
    on: {
      "click": function ($event) {
        _vm.showHelp = true;
      }
    }
  }, [_c('help-button')], 1), _vm._v(" "), _c('help', {
    attrs: {
      "show-help": _vm.showHelp
    },
    on: {
      "close": function ($event) {
        _vm.showHelp = false;
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hidden lg:block w-1/4 bg-white h-screen"
  }, [_c('router-link', {
    staticClass: "flex items-center mt-16 ml-16",
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_c('icon', {
    staticClass: "text-indigo-600",
    attrs: {
      "name": "logo-neopass"
    }
  })], 1), _vm._v(" "), _c('illustration', {
    staticClass: "absolute my-auto inset-0 px-8 py-2 w-1/4",
    attrs: {
      "name": "check_validation"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-1 flex flex-col w-3/4 bg-gray-200 rounded-tl-large justify-center py-12 px-4 sm:px-6 lg:flex-none lg:pl-20 xl:pl-24"
  }, [_c('div', {
    staticClass: "mx-auto lg:ml-32 w-full max-w-lg"
  }, [_c('h1', {
    staticClass: "text-4xl font-normal leading-none text-gray-900 text-left"
  }, [_vm._v("\n        Creation de votre mot de passe\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "mt-4 text-base font-normal text-gray-600"
  }, [_vm._v("\n        Veuillez saisir un mot de passe qui permettra de vous authentifier.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-8"
  }, [_c('form', {
    attrs: {
      "action": "#"
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.createPassword.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "mt-1 relative rounded-md shadow-sm"
  }, [_vm.passwordFieldType === 'checkbox' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.password,
      expression: "form.password"
    }],
    staticClass: "appearance-none block w-full text-lg py-5 px-5 border border-indigo-600 rounded-md placeholder-gray-600 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 transition duration-150 ease-in-out leading-5 mb-8",
    attrs: {
      "id": "password",
      "placeholder": "Mot de passe",
      "required": "",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.password) ? _vm._i(_vm.form.password, null) > -1 : _vm.form.password
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.form.password,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.form, "password", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.form, "password", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.form, "password", $$c);
        }
      }
    }
  }) : _vm.passwordFieldType === 'radio' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.password,
      expression: "form.password"
    }],
    staticClass: "appearance-none block w-full text-lg py-5 px-5 border border-indigo-600 rounded-md placeholder-gray-600 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 transition duration-150 ease-in-out leading-5 mb-8",
    attrs: {
      "id": "password",
      "placeholder": "Mot de passe",
      "required": "",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.form.password, null)
    },
    on: {
      "change": function ($event) {
        return _vm.$set(_vm.form, "password", null);
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.password,
      expression: "form.password"
    }],
    staticClass: "appearance-none block w-full text-lg py-5 px-5 border border-indigo-600 rounded-md placeholder-gray-600 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 transition duration-150 ease-in-out leading-5 mb-8",
    attrs: {
      "id": "password",
      "placeholder": "Mot de passe",
      "required": "",
      "type": _vm.passwordFieldType
    },
    domProps: {
      "value": _vm.form.password
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "password", $event.target.value);
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer",
    on: {
      "click": function ($event) {
        return _vm.switchVisibility(1);
      }
    }
  }, [_vm.passwordFieldType === 'password' ? _c('icon', {
    staticClass: "h-5 w-5 text-pink-600",
    attrs: {
      "name": "eye"
    }
  }) : _c('icon', {
    staticClass: "h-5 w-5 text-pink-600",
    attrs: {
      "name": "eye-off"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mt-1 relative rounded-md shadow-sm"
  }, [_vm.passwordFieldType2 === 'checkbox' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.password_confirmation,
      expression: "form.password_confirmation"
    }],
    staticClass: "appearance-none block w-full text-lg py-5 px-5 border border-indigo-600 rounded-md placeholder-gray-600 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 transition duration-150 ease-in-out leading-5",
    attrs: {
      "id": "password_confirmation",
      "placeholder": "Confirmation du mot de passe",
      "required": "",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.password_confirmation) ? _vm._i(_vm.form.password_confirmation, null) > -1 : _vm.form.password_confirmation
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.form.password_confirmation,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.form, "password_confirmation", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.form, "password_confirmation", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.form, "password_confirmation", $$c);
        }
      }
    }
  }) : _vm.passwordFieldType2 === 'radio' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.password_confirmation,
      expression: "form.password_confirmation"
    }],
    staticClass: "appearance-none block w-full text-lg py-5 px-5 border border-indigo-600 rounded-md placeholder-gray-600 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 transition duration-150 ease-in-out leading-5",
    attrs: {
      "id": "password_confirmation",
      "placeholder": "Confirmation du mot de passe",
      "required": "",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.form.password_confirmation, null)
    },
    on: {
      "change": function ($event) {
        return _vm.$set(_vm.form, "password_confirmation", null);
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.password_confirmation,
      expression: "form.password_confirmation"
    }],
    staticClass: "appearance-none block w-full text-lg py-5 px-5 border border-indigo-600 rounded-md placeholder-gray-600 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 transition duration-150 ease-in-out leading-5",
    attrs: {
      "id": "password_confirmation",
      "placeholder": "Confirmation du mot de passe",
      "required": "",
      "type": _vm.passwordFieldType2
    },
    domProps: {
      "value": _vm.form.password_confirmation
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "password_confirmation", $event.target.value);
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer",
    on: {
      "click": function ($event) {
        return _vm.switchVisibility(2);
      }
    }
  }, [_vm.passwordFieldType2 === 'password' ? _c('icon', {
    staticClass: "h-5 w-5 text-pink-600",
    attrs: {
      "name": "eye"
    }
  }) : _c('icon', {
    staticClass: "h-5 w-5 text-pink-600",
    attrs: {
      "name": "eye-off"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mt-8 space-y-4 flex flex-col items-center sm:space-y-0 sm:flex-row"
  }, [_c('big-action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "CONTINUER",
      "spinner": _vm.loading,
      "right": true,
      "icon": "arrow-right_1",
      "type-shadow": "shadow-pink"
    }
  })], 1), _vm._v(" "), _c('v-errors', {
    staticClass: "mt-6 text-xs font-medium text-red-500",
    attrs: {
      "errors": Object.assign({}, _vm.errors)
    }
  })], 1)])])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }